import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import TopMenu from "./components/frame/TopMenu";
import SideBar from "./components/frame/SideBar";
import Footer from "./components/frame/Footer";
import AllRoutes from "./AllRoutes";
import { useNavigate } from "react-router-dom";
import { checkExpiration } from "./service/AuthService";

const MainPage = () => {
  const currentUser = useSelector((state) => state.user.data);
  const navigate = useNavigate();

  // Check token expiration and redirect if necessary
  useEffect(() => {
    if (currentUser && checkExpiration(currentUser.authenticationToken)) {
      console.log("Token expired! Forcing logout");
      navigate("/logout");
    }
  }, [currentUser, navigate]);

  return (
    <div className="d-flex flex-column vh-100">
      {/* Top Navbar */}
      <TopMenu />

      {/* Main Content Area with Sidebar */}
      <div className="d-flex flex-grow-1 overflow-hidden">
        {/* Render SideBar only if a user is logged in */}
        {currentUser && (
          <div className="flex-shrink-0">
            <SideBar />
          </div>
        )}

        {/* Main Content: fluid container fills the remaining space */}
        <div className="flex-grow-1 p-4 overflow-auto" style={{ minWidth: 0 }}>
          <Container fluid>
            <AllRoutes />
          </Container>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default MainPage;
